import { SkeletonTheme } from 'react-loading-skeleton'

import {
  ProposalProvider,
  LpControlProvider,
  LeadProvider
} from '@itau-loans-www/hooks'

const wrapWithProvider = ({ element }) => {
  return (
    <LpControlProvider>
      <LeadProvider>
        <SkeletonTheme>
          <ProposalProvider>{element}</ProposalProvider>
        </SkeletonTheme>
      </LeadProvider>
    </LpControlProvider>
  )
}

export default wrapWithProvider
